









































import {
  Component,
  Prop,
  Vue,
  Watch,
} from 'vue-property-decorator';
import text from '@/data/text';

@Component
export default class Services extends Vue {
  /**
   * The service code.
   */
  @Prop() code!: string;

  services: any = text.services;

  serviceText: any;

  constructor() {
    super();

    this.serviceText = (this.services as any)[this.code];
  }

  @Watch('code')
  private onCodeChanged(value: string) {
    this.serviceText = (this.services as any)[value];
  }
}
